module.exports = __webpack_public_path__ + "img/blob1.db082161.svg";